export default "__VITE_ASSET__CFqIdfbd__"